import type { GroupDetail } from 'models';
import { useState } from 'react';
import { Modal } from 'ui';
import { UsersHorizontalScrollCard } from 'features/users';
import { useGroupUsersInfiniteQuery } from '../../queries';
import { GroupAdminsList } from './group-admins-list';

type P = {
  group: GroupDetail;
};

const GroupAdminsCard = ({ group }: P) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: administrators, isLoading } = useGroupUsersInfiniteQuery({
    filter: { groupId: group.id },
    pagination: { pageSize: 10 },
  });

  const allAdministrators = administrators?.pages[0]?.data ?? [];
  const allAdministratorsTotal = administrators?.pages[0]?.total ?? 0;

  if (!isLoading && (!allAdministratorsTotal || allAdministrators.length === 0)) {
    return null;
  }

  return (
    <>
      <UsersHorizontalScrollCard
        isLoading={isLoading}
        onClick={() => {
          setIsModalOpen(true);
        }}
        title="Admins"
        users={allAdministrators}
        usersTotal={allAdministratorsTotal}
      />

      <Modal
        isOpened={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        title="Admins"
      >
        <Modal.ScrollableContent>
          <GroupAdminsList groupId={group.id} />
        </Modal.ScrollableContent>
      </Modal>
    </>
  );
};

export default GroupAdminsCard;
